import { useCallback, useRef } from "react";

export default function useNamedDebouncedCallback(callback, wait) {
  const timeout = useRef();
  const prevName = useRef();

  return useCallback(
    function (name) {
      clearInterval(timeout.current);
      if (prevName.current !== name) {
        callback.apply(this, arguments);
      } else {
        timeout.current = setTimeout(() => {
          timeout.current = null;
          callback.apply(this, arguments);
        }, wait);
      }
      prevName.current = name;
    },
    [callback, wait]
  );
}
